module.exports = __webpack_public_path__ + "static/slika-3-02cb48eb806bf53ddd34c6c2c2effde9.png";